import ColoredSparksIcon from '@icons/colored-sparks.svg?react';
import Styled from './Header.styled';

function Header() {
  return (
    <Styled.Header data-testid="spark-welcome-header">
      <Styled.Gfx>
        <ColoredSparksIcon width={32} height={32} />
      </Styled.Gfx>
      <Styled.Title>
        Get the answers you need to <br />
        ignite your next big idea.
      </Styled.Title>
    </Styled.Header>
  );
}

export default Header;
